<template>
  <v-container
    height="100%"
    class="d-flex flex-column justify-center align-center"
  >
    <v-progress-circular
      class="center-all"
      v-if="getProgress"
      :rotate="360"
      :size="isMobile ? 50 : 150"
      :width="isMobile ? 5 : 15"
      :model-value="getProgress"
      :color="progressColor"
    >
      {{ Math.ceil(getProgress || 0) }}%
    </v-progress-circular>
    <v-progress-circular
      v-else
      class="center-all"
      :size="isMobile ? 50 : 150"
      :width="isMobile ? 5 : 15"
      color="primary"
      indeterminate
    />
    <h1 class="d-flex justify-center align-center mt-10">
      {{ messages }}
    </h1>
  </v-container>
</template>

<script setup lang="ts">
import { useAppStore } from '@/store/app'

const { loadingMessages: messages, getProgress } = storeToRefs(useAppStore())

const progressColor = computed(() => {
  if (!getProgress.value) return 'primary'
  if (getProgress.value < 30) {
    return 'red'
  } else if (getProgress.value < 60) {
    return 'pink'
  } else if (getProgress.value < 90) {
    return 'yellow'
  } else {
    return 'light-green accent-3'
  }
})
</script>
